import React, { useEffect, useRef, useState } from "react";
import FlyerHtmlPreview from "./FlyerHtmlPreview";

const A4_W = 794;
const A4_H = 1123;

/**
 * Wrapper that scales the A4 preview to fit the container width.
 */
const FlyerPreview = ({ flyer }) => {
  const containerRef = useRef(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const recalc = () => {
      if (!containerRef.current) return;
      const { clientWidth, clientHeight } = containerRef.current;
      const sx = (clientWidth - 32) / A4_W;
      const sy = (clientHeight - 32) / A4_H;
      setScale(Math.min(sx, sy, 1.2));
    };
    recalc();
    const ro = new ResizeObserver(recalc);
    if (containerRef.current) ro.observe(containerRef.current);
    window.addEventListener("resize", recalc);
    return () => {
      ro.disconnect();
      window.removeEventListener("resize", recalc);
    };
  }, []);

  return (
    <div
      ref={containerRef}
      data-testid="flyer-preview-container"
      className="w-full h-full rounded-2xl border border-stone-200 bg-[#E9E5DA] shadow-inner overflow-auto flex items-start justify-center p-4"
    >
      <div
        style={{
          width: A4_W * scale,
          height: A4_H * scale,
          flexShrink: 0,
        }}
      >
        <FlyerHtmlPreview flyer={flyer} scale={scale} />
      </div>
    </div>
  );
};

export default FlyerPreview;
